import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import AppContainer from "./AppContainer";

const LoaderComponent = () => (
  <AppContainer>
    <div className="fixed inset-0 z-[95] flex items-center justify-center">
      <Loader type="Oval" color="#ccc" height={40} width={40} timeout={3000} />
    </div>
  </AppContainer>
);

export default LoaderComponent;
